import { Button } from '@mantine/core';

import { endSession } from '@/utils/session';

export const LogoutButton = () => {
  return (
    <Button onClick={endSession} variant="outline" color="red">
      Logout
    </Button>
  );
};
